import Icon from '../components/Icon.vue'

Icon.register({"calendar":{"width":448,"height":512,"paths":[{"d":"M12 192H436C442.6 192 448 197.4 448 204V464C448 490.5 426.5 512 400 512H48C21.5 512 0 490.5 0 464V204C0 197.4 5.4 192 12 192zM448 148V112C448 85.5 426.5 64 400 64H352V12C352 5.4 346.6 0 340 0H300C293.4 0 288 5.4 288 12V64H160V12C160 5.4 154.6 0 148 0H108C101.4 0 96 5.4 96 12V64H48C21.5 64 0 85.5 0 112V148C0 154.6 5.4 160 12 160H436C442.6 160 448 154.6 448 148z"}]}})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/calendar.js
// module id = null
// module chunks = 